import { useTransaction } from "hooks/useTransactions";
import Button from "pages/_components/Button";
import Action from "pages/_components/Action";
import * as i18n from "util/i18n";
import { ResponsiveHeader, MobileButtons } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { bool } from "prop-types";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { isIOS } from "react-device-detect";
import { actions as creditBillActions } from "reducers/creditBills";
import { TransmitFCEMSummaryBody } from "./components/SummaryBody";

const TransmitFCEMTransactionPage = ({ isDesktop }) => {
    const formatData = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        push,
        id,
        status,
        showSignButton,
    } = useTransaction(
        `/creditBills/transmission/confirm`,
        creditBillActions.setActionData,
        creditBillActions.cleanServiceTicket,
        formatData,
    );

    const { isFlowComplete, isFinished, isBackoffice } = status;
    const { componentRef, handlePrint, handlePrintMobile, mobileRef, handleShareMobile } = useReactPrint(
        "creditBill.transmit",
        id,
        "servicePaymentTransactionPage",
    );
    const backLinkTo = isFlowComplete ? "/creditBills" : "";

    const [showMoreData, setShowMoreData] = useState(!isDesktop);

    const handleDownloadMobile = async () => {
        await setShowMoreData(true);
        return handlePrintMobile();
    };
    const handleDownloadDesktop = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="servicePaymentTransactionPage" />
            {!isBackoffice && (
                <ResponsiveHeader
                    ticket
                    metaTitle="creditBill.transmit"
                    id="creditBill.transmit"
                    backLinkTo={backLinkTo}>
                    {isFinished && (
                        <>
                            <MobileButtons
                                image={
                                    isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"
                                }>
                                <Action labelKey="global.download" handleClick={handleDownloadMobile} />
                                <Action labelKey="global.share" handleClick={handleShareMobile} />
                            </MobileButtons>
                        </>
                    )}
                </ResponsiveHeader>
            )}
            <MainContainer showLoader={isLoading} className="credit-bills">
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="creditBill.transmit" isDesktop={isDesktop} />

                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <TransmitFCEMSummaryBody
                                        isTicket
                                        isDesktop={isDesktop}
                                        isFinished={isFinished}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={!showSignButton && !status.isFinished ? 4 : 2}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${
                                        showSignButton || status.isFinished ? " btn-outline" : " btn-primary"
                                    }`}
                                />
                            </Col>
                            {status.isFinished && (
                                <>
                                    <Col xs={12} md={4}>
                                        <Button
                                            onClick={handleDownloadDesktop}
                                            label="global.download"
                                            className="btn btn-primary"
                                            image="images/download.svg"
                                        />
                                    </Col>
                                    {!isDesktop && (
                                        <Col xs={12} md={4}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                </>
                            )}
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

TransmitFCEMTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default TransmitFCEMTransactionPage;
